import { useMotionValueEvent, useScroll } from 'framer-motion';
import { type RefObject, useState } from 'react';

const useIsCarouselScrolledToBottom = (
  carouselRef: RefObject<HTMLDivElement | null>,
): boolean => {
  const [isCarouselScrolledToBottom, setIsCarouselScrolledToBottom] =
    useState<boolean>(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (
      carouselRef.current?.getBoundingClientRect().bottom ===
        carouselRef.current?.parentElement?.getBoundingClientRect().bottom &&
      latest > 10
    ) {
      if (!isCarouselScrolledToBottom) {
        setIsCarouselScrolledToBottom(true);
      }
    } else {
      if (isCarouselScrolledToBottom) {
        setIsCarouselScrolledToBottom(false);
      }
    }
  });

  return isCarouselScrolledToBottom;
};

export default useIsCarouselScrolledToBottom;
